import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-submitted',
  template: `
  <app-header class="request-banner"  bannerImage="sprayer-sky.webp"></app-header>
  <h1 i18n="@@RequestSubmitted">Request Submitted</h1>
  
  <p i18n="@@RequestText">Your request is now on its way to our chemists. They should be in touch with you shortly.</p>
  
  `
})
export class RequestSubmittedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
